import { useState, useContext } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import { AuthContext } from 'context/authContext';
import Avatar from 'assets/images/avatar.png';

import Switch from 'components/atoms/Switch';
import { ThemeContext } from 'context/themeContext';
import {
  ProfileHolder,
  UserWrap,
  ImgBox,
  TextBox,
  DropDown,
  Ul,
  Li,
  StyledLink,
  Name,
  Text,
  IconHolder,
} from './UserActions.styles';

function UserActions() {
  const { onLogout } = useContext(AuthContext);
  const { theme, setTheme } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  function isDark() {
    return theme === 'dark';
  }

  const onSwitchToggle = e => {
    setTheme(e.target.checked ? 'dark' : 'light');
    setIsOpen(!isOpen);
  };

  return (
    <ProfileHolder>
      <UserWrap onClick={() => setIsOpen(!isOpen)}>
        <ImgBox>
          <img src={Avatar} width="40" height="40" alt="user" />
        </ImgBox>
        <TextBox>
          <Name>User</Name>
        </TextBox>
        <i className="icon-chevron-down" />
      </UserWrap>

      <DropDown dropdownOpen={isOpen}>
        <Ul>
          <Li index="1">
            <Switch
              noMargin
              themeSwitch
              name="moodSwitch"
              checked={isDark()}
              onChange={onSwitchToggle}
              label={
                <div className="switch-text">
                  <IconHolder as="div">
                    <i className="icon-moon" />
                  </IconHolder>{' '}
                  <Text as="div"> Mood</Text>
                </div>
              }
            />
          </Li>
          <Li index="2">
            <StyledLink to="/brand/account" onClick={() => setIsOpen(!isOpen)}>
              <IconHolder>
                <i className="icon-person" />
              </IconHolder>
              <Text>Account</Text>
            </StyledLink>
          </Li>
          <Li index="3">
            <StyledLink
              as="span"
              css="cursor: pointer;"
              onClick={e => {
                e.preventDefault();
                onLogout();
              }}>
              <IconHolder>
                <i className="icon-logout" />
              </IconHolder>
              <Text>Logout</Text>
            </StyledLink>
          </Li>
        </Ul>
      </DropDown>
    </ProfileHolder>
  );
}

export default UserActions;
